import {Injectable} from "@angular/core";
import {ReplicationService} from "./replication.service";
import {GroupService} from "./group.service";
import {GroupCredentials, NewGroupInfos, ReplicationInfos} from "../models/group.model";
import {LocalSettingsService} from "./local-settings.service";
import {Group, HealthcareParty, User} from "@icure/api";
import {HcpService} from "./hcp.service";
import {UserService} from "./user.service";
// @ts-ignore
import {v4 as uuidv4} from 'uuid';
import {Role} from "../models/roles.model";

export const GROUP_ID_TEMPLATE = 'ms-db-template-d60b237e-f51a-4162-aa54-ac25a061151b';

//export const GROUP_ID_TEMPLATE = 'ms-kine-working-group-cbe920f2-a4c1-44b2-ad45-cb40c26a4c2b';


@Injectable({
  providedIn: 'root',
})
export class ToolsService {
  constructor(
    private replicationService: ReplicationService,
    private groupService: GroupService,
    private localSetting: LocalSettingsService,
    private hcpService: HcpService,
    private userService: UserService,
  ) {
  }

  public async launchGroupCreation(newGroupInfos: NewGroupInfos): Promise<any> {
    if (newGroupInfos?.groupId) {
      const createGroupReturn = await this.createGroup(newGroupInfos?.groupId);
      if (createGroupReturn?.status?.status === 200) {
        const parentPassword: string = uuidv4();
        const userPassword: string = uuidv4();
        //Launch replication

        //Create parent User
        const parentHcp: HealthcareParty | undefined = await this.hcpService.addHcpInGroup(createGroupReturn?.content?.id!!, {
          id: uuidv4(),
          name: 'utilisateur principal',
        });

        const parentUser: User | undefined = await this.userService.addUserInGroup(createGroupReturn?.content?.id!!, {
          id: uuidv4(),
          healthcarePartyId: parentHcp?.id!!,
          name: 'utilisateur principal',
          login: `${newGroupInfos?.groupId}@medispring.be`,
          email: `${newGroupInfos?.groupId}@medispring.be`,
          // @ts-ignore
          type: User.TypeEnum.Database,
          status: User.StatusEnum.ACTIVE,
          passwordHash: parentPassword,
          roles: [Role.MS_ADMIN],
          applicationTokens: {}
        });

        //Create user
        const mainUserHcp: HealthcareParty | undefined = await this.hcpService.addHcpInGroup(createGroupReturn?.content?.id!!, {
          id: uuidv4(),
          firstName: newGroupInfos?.mainUserFirstName,
          lastName: newGroupInfos?.mainUserLastName,
          ssin: newGroupInfos?.mainUserInss || '',
          nihii: newGroupInfos?.mainUserNihii || '',
          parentId: parentHcp?.id
        });

        const mainUser: User | undefined = await this.userService.addUserInGroup(createGroupReturn?.content?.id!!, {
          id: uuidv4(),
          healthcarePartyId: mainUserHcp?.id!!,
          name: `${newGroupInfos?.mainUserFirstName} ${newGroupInfos?.mainUserLastName}`,
          email: newGroupInfos?.mainUserEmail,
          login: newGroupInfos?.mainUserEmail,
          // @ts-ignore
          autoDelegations: {["all"]: [parentHcp?.id]} || {},
          type: User.TypeEnum.Database,
          status: User.StatusEnum.ACTIVE,
          passwordHash: userPassword,
          roles: [Role.MS_ADMIN, Role.MS_PRACTICIAN],
          applicationTokens: {}
        });

        return {
          group: createGroupReturn?.content,
          parent: {
            hcp: parentHcp,
            user: parentUser,
            password: parentPassword
          },
          mainUser: {
            hcp: mainUserHcp,
            user: mainUser,
            password: userPassword
          }
        }
        /*return {
          group: {
            id: "ms-db-test-cockpit-2f8cf389-ebac-424b-803c-dce17690a7eb",
            rev: "1-c3e50621e34596932ff3de3a2aa77835",
            tags: [
              {
                "id": "IC-GROUP|database|1.0",
                "type": "IC-GROUP",
                "code": "database",
                "version": "1.0"
              }
            ],
            name: "ms-db-test-cockpit-2f8cf389-ebac-424b-803c-dce17690a7eb",
            password: "286328f5-8d43-4d88-b8cb-d17d1deb6b59",
            servers: [
              "https://couch-cluster-02.icure.cloud:444"
            ],
            superAdmin: false,
            defaultUserRoles: {},
            operationTokens: {},
            sharedEntities: {},
            minimumAuthenticationClassForElevatedPrivileges: "PASSWORD",
            superGroup: "ms-superadmin"
          },
          parent: {
            hcp: {
              id: "af76de0a-da64-4458-9790-de1451683b52",
              rev: "1-5d69dd443d0cec8a118f76d15e31de68",
              created: 1757598167141,
              modified: 1757598167141,
              identifier: [],
              tags: [],
              codes: [],
              name: "utilisateur principal",
              names: [
                {
                  firstNames: [],
                  prefix: [],
                  suffix: [],
                  text: "utilisateur principal",
                  use: "official"
                }
              ],
              addresses: [],
              languages: [],
              statuses: [],
              statusHistory: [],
              specialityCodes: [],
              sendFormats: {},
              financialInstitutionInformation: [],
              descr: {},
              flatRateTarifications: [],
              importedData: {},
              options: {},
              properties: [],
              hcPartyKeys: {},
              aesExchangeKeys: {},
              transferKeys: {},
              privateKeyShamirPartitions: {}
            },
            user: {
              id: "e8088004-d778-4e25-826d-52b206a4cea9",
              rev: "1-26f76a0a889355d7d33f5c14a7dceed8",
              created: 1757598167302,
              name: "utilisateur principal",
              properties: [],
              permissions: [],
              roles: [
                "MS_ADMIN"
              ],
              type: "database",
              status: "ACTIVE",
              login: "ms-db-test-cockpit-2f8cf389-ebac-424b-803c-dce17690a7eb@medispring.be",
              passwordHash: "*",
              groupId: "ms-db-test-cockpit-2f8cf389-ebac-424b-803c-dce17690a7eb",
              healthcarePartyId: "af76de0a-da64-4458-9790-de1451683b52",
              autoDelegations: {},
              createdDate: 1757598167302,
              email: "ms-db-test-cockpit-2f8cf389-ebac-424b-803c-dce17690a7eb@medispring.be",
              applicationTokens: {},
              authenticationTokens: {}
            },
            password: "1a115099-e76c-450c-b613-34d5f199572c"
          },
          mainUser: {
            hcp: {
              id: "69fe6b7a-8376-4761-b768-5da37f2e4ddc",
              rev: "1-dab582e4a91e49522d3c6ff6494284ea",
              created: 1757598167418,
              modified: 1757598167418,
              identifier: [],
              tags: [],
              codes: [],
              name: "Mennechet Maxime",
              lastName: "Mennechet",
              firstName: "Maxime",
              names: [
                {
                  lastName: "Mennechet",
                  firstNames: [
                    "Maxime"
                  ],
                  prefix: [],
                  suffix: [],
                  text: "Mennechet Maxime",
                  use: "official"
                }
              ],
              parentId: "af76de0a-da64-4458-9790-de1451683b52",
              nihii: "12345678910",
              ssin: "92092412781",
              addresses: [],
              languages: [],
              statuses: [],
              statusHistory: [],
              specialityCodes: [],
              sendFormats: {},
              financialInstitutionInformation: [],
              descr: {},
              flatRateTarifications: [],
              importedData: {},
              options: {},
              properties: [],
              hcPartyKeys: {},
              aesExchangeKeys: {},
              transferKeys: {},
              privateKeyShamirPartitions: {}
            },
            user: {
              id: "2975ad7a-0136-4533-9d82-1f18fce7b05d",
              rev: "1-f61f9280f4d5e04efa706cafdcd98893",
              created: 1757598167558,
              name: "Maxime Mennechet",
              properties: [],
              permissions: [],
              roles: [
                "MS_ADMIN",
                "MS_PRACTICIAN"
              ],
              type: "database",
              status: "ACTIVE",
              login: "cockpit@medispring.be",
              passwordHash: "*",
              groupId: "ms-db-test-cockpit-2f8cf389-ebac-424b-803c-dce17690a7eb",
              healthcarePartyId: "69fe6b7a-8376-4761-b768-5da37f2e4ddc",
              autoDelegations: {
                all: [
                  "af76de0a-da64-4458-9790-de1451683b52"
                ]
              },
              createdDate: 1757598167558,
              email: "cockpit@medispring.be",
              applicationTokens: {},
              authenticationTokens: {}
            },
            password: "7614ef98-ae92-4126-9eac-3b47e9c02cc8"
          }
        }*/
      } else {
        console.error('Error creating group', createGroupReturn);
      }
    }
  }

  private async createGroup(groupId: string) {
    const basicAuth = atob(this.localSetting?.basicAuth)
    const dbTemplate: Group = this.localSetting?.listOfGroups?.find(group => group.id === GROUP_ID_TEMPLATE)!!;
    const credentials: GroupCredentials = {
      login: basicAuth?.split(':')[0],
      password: basicAuth?.split(':')[1],
    }
    if (dbTemplate?.id && credentials?.login!!) {
      const replicationInfos: ReplicationInfos = {
        replication: {
          id: "1",
          name: groupId,
          context: 'ms-group',
          //databaseSynchronizations: [
          //  {
          //    source: `https://${credentials.login}:${credentials.password}@${dbTemplate?.servers?.[0]?.replace('https://', '')!!}/icure-${dbTemplate?.id}`,
          //    target: `base`,
          //  }
          //]
        }
      }
      return await this.groupService.createGroup(groupId, credentials, replicationInfos)
      /*return {
        status: {
          status: 200,
        },
        content: {
          id: "ms-db-test-cockpit-2f8cf389-ebac-424b-803c-dce17690a7eb",
          rev: "1-c3e50621e34596932ff3de3a2aa77835",
          tags: [
            {
              "id": "IC-GROUP|database|1.0",
              "type": "IC-GROUP",
              "code": "database",
              "version": "1.0"
            }
          ],
          name: "ms-db-test-cockpit-2f8cf389-ebac-424b-803c-dce17690a7eb",
          password: "286328f5-8d43-4d88-b8cb-d17d1deb6b59",
          servers: [
            "https://couch-cluster-02.icure.cloud:444"
          ],
          superAdmin: false,
          defaultUserRoles: {},
          operationTokens: {},
          sharedEntities: {},
          minimumAuthenticationClassForElevatedPrivileges: "PASSWORD",
          superGroup: "ms-superadmin"
        }
    }*/
    } else {
      console.error('Error creating group, missing db template or credentials', dbTemplate, credentials);
      return {
        status: {
          status: 400,
          statusText: "Error creating group, missing db template or credentials"
        },
        content: {}
      }
    }
  }
}
